import styles from "./FreightRevenue.module.scss";
import {
  Checkbox,
  Col,
  Divider,
  Modal,
  Row,
  Table,
  message,
  Form as FormAntd,
  Button,
  Pagination,
  Space,
} from "antd";
import {
  Form,
  HeaderTable,
  ModalImport,
  PermissionDirect,
  TableActionButtons,
  buildColumnsWithHeaderFilters,
} from "../../Components";
import { decorateEditableColumns } from "../../shared/helpers/editableColumns";
import { replaceRowByOriginalId } from "../../shared/helpers/rowState";
import { updateColumnDisplayState } from "../../shared/helpers/tableColumns";
import { resetPaginationToFirstPage } from "../../shared/helpers/pagination";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import {
  canApplyFreightVersion,
  getFreightVersionOrderCount,
} from "../../shared/helpers/freightVersion";
import { PlusIcon, Setting } from "../../assets/icon";
import { useEffect, useMemo, useState } from "react";
import {
  CommonApi,
  FreightRevenueApi,
  getPermissionRegions,
  RouteManagerApi,
  getPermissionDirections,
} from "../../services";
import dayjs from "dayjs";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditFilled,
  EyeOutlined,
} from "@ant-design/icons";
const { confirm } = Modal;
const { getAllRouterBase, getOneRouter } = RouteManagerApi;
import {
  buildFreightRevenueBasePayload,
  buildFreightRevenueDetailsPayload,
  buildFreightRevenueVersionPayload,
  hasNullRequiredField,
  updateFreightRevenueEditedRows,
} from "./helpers";
import {
  buildCustomerLookupOption,
  buildLookupRequestParams,
  buildRouteBaseLookupOption,
  customerLookupTable,
  type LookupFilters,
  routeBaseLookupTable,
} from "../../shared/lookupTables";
const apiDebounceRoute = (
  search: string,
  _value?: string,
  filters: LookupFilters = {},
) => {
  return getAllRouterBase(buildLookupRequestParams(search, filters), {
    silentLoading: true,
  }).then((res: any) => res.data?.map(buildRouteBaseLookupOption) || []);
};
const apiDebounceCustomer = (search: string) => {
  return FreightRevenueApi.getAllCustomer({ searchText: search }).then(
    (res: any) => res.data?.map(buildCustomerLookupOption) || [],
  );
};
// const apiDebounceProvince = (search: string) => {
//   return CommonApi.getSearchProvine({ searchText: search }).then((res: any) =>
//     res.data?.map((ite: any) => ({ label: ite.name, value: ite._id })),
//   );
// };
const FreightRevenue = () => {
  // Define constant
  const [loading, setLoading] = useState(false);
  const [increLoading, setIncreLoading] = useState(0);
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const [regionAndDirectionSelectOptions, setRegionAndDirectionSelectOptions] =
    useState<any>({
      region: [],
      direction: [],
    });
  // const [provines, setProvines] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [messageApi, contextHolder] = message.useMessage();
  const { isLocked, runLocked } = useRequestLock();
  const [editIndex, setEditIndex] = useState<any>([]);
  const [editIndexVersion, setEditIndexVersion] = useState<any>([]);
  const [formInstance] = FormAntd.useForm();
  const newObj = {
    _id: null,
    code: null,
    customer: null,
    routeBase: null,
    receiptAddress: null,
    deliveryAddress: null,
    price: null,
    deliveryCost: null,
    extraFee: null,
    validFrom: null,
    expiredDate: null,
    customerName: null,
  };
  // const [dataFreightRevenueVersion, setDataFreightRevenueVersion] =
  //   useState<any>([]);
  const [activeVersion, setActiveVersion] = useState<string | null>(null);
  const [dataVersion, setDataVersion] = useState<any[]>([]);
  const [openModalImport, setOpenModalImport] = useState(false);
  const canImportFreightRevenue = checkPermissions(
    "FREIGHT",
    "import",
    features,
  );
  const canEditFreight = checkPermissions("FREIGHT", "edit", features);
  const REQUIRED_FIELDS = ["code", "customerName"];
  const REQUIRED_FIELDS_VERSION = ["name", "note", "validFrom"];
  const [paginationFreightRevenue, setPaginationFreightRevenue] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const typeDelivery = [
    { label: "BẮC - NAM", value: "ROAD" },
    { label: "CẢNG", value: "EXIM" },
    { label: "BIÊN", value: "BORDER" },
    { label: "ĐƯỜNG THUỶ", value: "WATERWAY" },
    { label: "CHUYỂN KHO", value: "TRANSFER" },
  ];
  const columnsTableVersion: any = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 50,
      fixed: "left",
      hidden: false,
      render: (row: any, record: any, index: number) => index + 1,
    },
    {
      title: "Mã phiên bản",
      dataIndex: "name",
      editType: "Input",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      fixed: false,
      hidden: false,
      editType: "Input",
    },
    {
      title: "Ngày hiệu lực",
      dataIndex: "validFrom",
      editType: "DatePicker",
      colReturn: (row: any) => dayjs(row).format("DD/MM/YYYY"),
    },
    {
      title: "Đơn hàng bị ảnh hưởng",
      dataIndex: "affectedOrderCount",
      align: "center",
      width: 170,
      render: (value: unknown) => getFreightVersionOrderCount(value),
    },
    {
      title: "Đơn hàng chưa áp dụng",
      dataIndex: "pendingOrderCount",
      align: "center",
      width: 180,
      render: (value: unknown) => {
        const pendingOrderCount = getFreightVersionOrderCount(value);

        return (
          <span
            style={{
              color: pendingOrderCount > 0 ? "#ff4d4f" : undefined,
              fontWeight: pendingOrderCount > 0 ? 600 : undefined,
            }}
          >
            {pendingOrderCount}
          </span>
        );
      },
    },
    // {
    //   title: "Ngày hết hạn",
    //   dataIndex: "expiredDate",
    //   editType: "DatePicker",
    //   colReturn: (row: any) => dayjs(row).format("DD/MM/YYYY"),
    // },
    // {
    //   title: "Trạng thái",
    //   dataIndex: "state",
    //   render: (row: any, record: any) => (
    //     <div
    //       style={{
    //         color: record.state === "VALID" ? "#05ff00" : "#F63535",
    //         fontWeight: "bold",
    //       }}
    //     >
    //       {record.state === "VALID" ? "Đang hoạt động" : "Hết hạn"}
    //     </div>
    //   ),
    // },
    // {
    //   title: "",
    //   key: "action",
    //   fixed: true,
    //   width: 60,
    //   render: (_: any, record, index) => (
    //     <Button
    //       icon={<ArrowDownCircle />}
    //       onClick={() => {
    //         FreightRevenueApi.getExportVersion(record._id, record.name);
    //       }}
    //       disabled={!checkPermissions("FREIGHT", "export", features)}
    //     />
    //   ),
    // },
  ];
  const colsBase = [
    {
      title: "STT",
      dataIndex: "_id",
      width: 50,
      fixed: "left",
      hidden: false,
      render: (row: any, record: any, index: number) => index + 1,
    },
    {
      title: "Khách hàng",
      dataIndex: "customerName",
      filterDataIndex: "customer",
      width: 180,
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "debounce",
        filterProps: {
          showSearch: true,
          fetchOptions: apiDebounceCustomer,
          placeholder: "Nhập khách hàng",
        },
      },
      editType: "LookupTableSelect",
      editProps: (val: any, record: any, editIndex: any) => {
        return {
          ...customerLookupTable,
          fetchOptions: apiDebounceCustomer,
          disabled: !(record?.status === "new"),
        };
      },
      colReturn: (row: any) => row?.label ?? row,
    },
    {
      title: "Mã tuyến",
      dataIndex: "code",
      filterDataIndex: "searchText",
      width: 180,
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "string",
        filterProps: {
          placeholder: "Nhập mã tuyến",
        },
      },
      editType: "LookupTableSelect",
      editProps: (val: any, record: any, editIndex: any) => {
        return {
          ...routeBaseLookupTable,
          fetchOptions: apiDebounceRoute,
          disabled: !(record?.status === "new"),
          onChange: (val: any, dataSource: any) => {
            handleOnChangeRouter(val, record._id, dataSource);
          },
        };
      },
      colReturn: (row: any) => row?.label ?? row,
    },
    {
      title: "Khu vực",
      dataIndex: ["routeBase", "regionName"],
      filterDataIndex: "region",
      importTitle: "Khu vực",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: regionAndDirectionSelectOptions.region,
          placeholder: "Nhập mã tuyến",
        },
      },
      render: (row: any, record: any) => row ?? record?.routeBase?.region?.name,
    },
    {
      title: "Chiều hàng",
      dataIndex: ["routeBase", "direction"],
      filterDataIndex: "direction",
      importTitle: "Chiều hàng",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: regionAndDirectionSelectOptions.direction,
          placeholder: "Nhập mã tuyến",
        },
      },
      render: (row: any, record: any) => row ?? record?.routeBase?.direction,
    },
    {
      title: "Hình thức VC",
      dataIndex: ["routeBase", "roadType"],
      filterDataIndex: "roadType",
      importTitle: "Hình thức vận chuyển",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: typeDelivery,
          placeholder: "Nhập hình thức vận chuyển",
        },
      },
      render: (row: any) =>
        typeDelivery.find((ite) => ite.value === row)?.label,
    },
    {
      title: "Địa điểm",
      dataIndex: "location",
      children: [
        {
          title: "Điểm nhận",
          dataIndex: ["routeBase", "receipt", "address"],
          filterDataIndex: "receipt",
          importTitle: "Địa điểm nhận hàng",
          fixed: false,
          hidden: false,
          filterConfig: {
            type: "string",
            filterProps: {
              // showSearch: true,
              // options: provines,
              // optionFilterProp: "label",
              placeholder: "Nhập điểm nhận",
            },
          },
        },
        {
          title: "Điểm trả",
          dataIndex: ["routeBase", "delivery", "address"],
          filterDataIndex: "delivery",
          importTitle: "Địa điểm trả hàng",
          fixed: false,
          hidden: false,
          filterConfig: {
            type: "string",
            filterProps: {
              // showSearch: true,
              // options: provines,
              // optionFilterProp: "label",
              placeholder: "Nhập điểm trả",
            },
          },
        },
      ],
    },
    {
      title: "KM",
      dataIndex: "routeBase",
      children: [
        {
          title: "Km có hàng",
          dataIndex: ["routeBase", "haveGoodsDistance"],
          importTitle: "Km có hàng",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập km có hàng",
          //   },
          // },
          render: (row: any) => row ?? 0 + " km",
        },
        {
          title: "Km không hàng",
          dataIndex: ["routeBase", "noGoodsDistance"],
          importTitle: "Km không hàng",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập km không hàng",
          //   },
          // },
          render: (row: any) => row ?? 0 + " km",
        },
      ],
    },
    {
      title: "Cước vận chuyển",
      dataIndex: "price",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "number",
        filterProps: {
          placeholder: "Nhập số tiền",
        },
      },
      children: [
        {
          title: <div style={{ textAlign: "center" }}>CONT 20</div>,
          dataIndex: ["price", "cont20"],
          importTitle: "cont20",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập số tiền",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: <div style={{ textAlign: "center" }}>CONT 40</div>,
          dataIndex: ["price", "cont40"],
          importTitle: "cont40",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập số tiền",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: <div style={{ textAlign: "center" }}>CONT 45</div>,
          dataIndex: ["price", "cont45"],
          importTitle: "cont45",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Cước CY",
      dataIndex: "price",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "number",
        filterProps: {
          placeholder: "",
        },
      },
      children: [
        {
          title: <div style={{ textAlign: "center" }}> 20</div>,
          dataIndex: ["price", "cy20"],
          importTitle: "cy20",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: <div style={{ textAlign: "center" }}>40</div>,
          dataIndex: ["price", "cy40"],
          importTitle: "cy40",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: <div style={{ textAlign: "center" }}>45</div>,
          dataIndex: ["price", "cy45"],
          importTitle: "cy45",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Kẹp lệch",
      dataIndex: "price",
      fixed: false,
      hidden: false,
      children: [
        {
          title: <div style={{ textAlign: "center" }}>20</div>,
          dataIndex: ["price", "splitCont20"],
          importTitle: "Kẹp lệch",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Phí GN",
      dataIndex: "deliveryCost",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "number",
        filterProps: {
          placeholder: "",
        },
      },
      children: [
        {
          title: "Xuất",
          dataIndex: ["deliveryCost", "export"],
          importTitle: "Phí giao nhận Xuất",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "Nhập",
          dataIndex: ["deliveryCost", "import"],
          importTitle: "Phí giao nhận Nhập",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Phụ cước",
      dataIndex: "extraFee",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "number",
        filterProps: {
          placeholder: "",
        },
      },
      children: [
        {
          title: "Xuất",
          dataIndex: ["extraFee", "export"],
          importTitle: "Phụ cước Xuất",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "Nhập",
          dataIndex: ["extraFee", "import"],
          importTitle: "Phụ cước Nhập",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
  ];
  const [columns, setColumns] = useState<any>(colsBase);
  const configInputImportForm: any = {
    dataSource: {
      table: `posts`,
      update: {
        isBackendData: false,
      },
    },
    fields: [
      {
        displayType: "Group",
        dataIndex: "_id",
        col: { span: 24 },
        divider: true,
        className: [styles.FormItem].join(" "),
        fields: [
          {
            label: "Phiên bản", // show label
            dataIndex: "name", // key
            displayType: "Select", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              onChange: (name: any) => {
                if (name !== "new") {
                  const selectedVersion: any = dataVersion.find(
                    (item: any) => item._id === name,
                  );
                  formInstance.setFieldsValue({
                    expiredDate: selectedVersion
                      ? dayjs(selectedVersion?.expiredDate)
                      : null,
                  });
                } else {
                  formInstance.setFieldsValue({ expiredDate: null });
                }
              },
              options: [
                {
                  label: "Phiên bản mới",
                  value: "new",
                },
                ...(dataVersion?.length > 0
                  ? dataVersion.map((item: any) => ({
                      label: item.name,
                      value: item._id,
                    }))
                  : []),
              ],
            },
          },
          {
            label: "Ngày hiệu lực", // show label
            dataIndex: "expiredDate", // key
            displayType: "DatePicker", // type input
            col: { span: 12 },
            rules: [
              {
                required: true,
                message: "Không được để trống phần này",
              },
            ],
            input: {
              disabled: FormAntd.useWatch("name", formInstance) !== "new",
              style: { width: "100%" },
            },
          },
          {
            label: "Sao chép từ phiên bản cũ", // show label
            dataIndex: "onCopy", // key
            displayType: "SwitchToggle", // type input
            col: { span: 12 },
            rules: [],
            input: {
              disabled: FormAntd.useWatch("name", formInstance) !== "new",
            },
          },
          {
            label: "Phiên bản cần sao chép", // show label
            dataIndex: "cloneFromVersion", // key
            displayType: "Select", // type input
            col: { span: 12 },
            rules: [
              {
                required: FormAntd.useWatch("onCopy", formInstance),
                message: "Chưa chọn phiên bản cần sao chép",
              },
            ],
            input: {
              disabled: !FormAntd.useWatch("onCopy", formInstance),
              options: [
                ...(dataVersion?.length > 0
                  ? dataVersion.map((item: any) => ({
                      label: item.name,
                      value: item._id,
                    }))
                  : []),
              ],
            },
          },
        ],
      },
    ],
  };
  const [filters, setFilters] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [onModalPostion, setOnModalPosition] = useState(false);
  const handleFreightRevenueFiltersChange = (nextFilters: any) => {
    setPaginationFreightRevenue((prev) =>
      resetPaginationToFirstPage(prev),
    );
    setFilters((prev: any) =>
      typeof nextFilters === "function" ? nextFilters(prev) : nextFilters,
    );
  };
  const handleFreightRevenueVersionChange = (versionId: string) => {
    setPaginationFreightRevenue((prev) =>
      resetPaginationToFirstPage(prev),
    );
    setActiveVersion(versionId);
  };
  const columnsRender = buildColumnsWithHeaderFilters(
    [
      ...decorateEditableColumns(columns, {
        editIndex,
        getDataSource: () => dataSource,
        onUpdate: (dataIndex, value, rowId) =>
          handleUpdateRow(dataIndex, value, rowId),
      }),
      {
        title: "",
        key: "action",
        width: 60,
        fixed: "right",
        render: (_: any, record: any, index: number) => {
          const saveAction = record.status === "new" ? "add" : "edit";
          const canSave = checkPermissions(
            "FREIGHT",
            saveAction,
            features,
          );

          return editIndex.find((ind: any) => ind.index === record._id) ? (
            <div>
              <Button
                loading={isLocked(`freight-revenue:row:${record._id}`)}
                disabled={
                  isLocked(`freight-revenue:row:${record._id}`) || !canSave
                }
                onClick={() => {
                  handleActionSave(record._id, index);
                }}
              >
                Lưu
              </Button>{" "}
              <Button
                disabled={isLocked(`freight-revenue:row:${record._id}`)}
                onClick={() => {
                  handleActionCancel(record._id);
                }}
              >
                Hủy
              </Button>
            </div>
          ) : (
            <TableActionButtons
              items={[
                {
                  key: "detail",
                  label: "Chi tiết",
                  icon: <EyeOutlined />,
                  tone: "info",
                  onClick: () =>
                    handleActionTable("detail", record, record._id),
                },
                {
                  key: "edit",
                  label: "Chỉnh sửa",
                  icon: <EditFilled />,
                  tone: "edit",
                  disabled: !checkPermissions("FREIGHT", "edit", features),
                  onClick: () => handleActionTable("edit", record, record._id),
                },
                {
                  key: "delete",
                  label: "Xoá",
                  icon: <DeleteOutlined />,
                  tone: "delete",
                  danger: true,
                  disabled: !checkPermissions("FREIGHT", "delete", features),
                  onClick: () =>
                    handleActionTable("delete", record, record._id),
                },
              ]}
            />
          );
        },
      },
    ],
    filters,
    handleFreightRevenueFiltersChange,
  );
  const columnsRenderVersion: any = [
    ...decorateEditableColumns(columnsTableVersion, {
      editIndex: editIndexVersion,
      getDataSource: () => dataVersion,
      onUpdate: (dataIndex, value, rowId) =>
        handleUpdateRowVersion(dataIndex, value, rowId),
    }),
    {
      title: "",
      key: "action",
      fixed: true,
      width: 280,
      render: (_: any, record: any, index: number) =>
        editIndexVersion.find((ind: any) => ind.index === record._id) ? (
          <div>
            <Button
              loading={isLocked(`freight-revenue:version:${record._id}`)}
              disabled={
                isLocked(`freight-revenue:version:${record._id}`) ||
                !canEditFreight
              }
              onClick={() => {
                handleActionSaveVersion(record._id, index);
              }}
            >
              Lưu
            </Button>{" "}
            <Button
              disabled={isLocked(`freight-revenue:version:${record._id}`)}
              onClick={() => {
                handleActionCancelVersion(record._id);
              }}
            >
              Hủy
            </Button>
          </div>
        ) : (
          <Space size={8}>
            <TableActionButtons
              items={[
                {
                  key: "edit",
                  label: "Chỉnh sửa",
                  icon: <EditFilled />,
                  tone: "edit",
                  disabled: !checkPermissions(
                    "FREIGHT",
                    "edit",
                    features,
                  ),
                  onClick: () =>
                    handleActionTableVersion("edit", record, record._id),
                },
                {
                  key: "download",
                  label: "Tải xuống",
                  icon: <DownloadOutlined />,
                  tone: "download",
                  disabled: !checkPermissions(
                    "FREIGHT",
                    "export",
                    features,
                  ),
                  onClick: () =>
                    handleActionTableVersion("download", record, record._id),
                },
              ]}
            />
            {canApplyFreightVersion(record, canEditFreight) && (
              <Button
                type="primary"
                loading={isLocked(
                  `freight-revenue:apply-version:${record._id}`,
                )}
                disabled={isLocked(
                  `freight-revenue:apply-version:${record._id}`,
                )}
                onClick={() => handleApplyFreightRevenueVersion(record)}
              >
                Áp dụng giá mới
              </Button>
            )}
          </Space>
        ),
      // render: (_: any, record: any, index: number) => (
      //   <Row justify="space-between">
      //     <Button
      //       icon={<ArrowDownCircle />}
      //       onClick={() => {
      //         ;
      //       }}
      //       disabled={
      //         !checkPermissions("FIXED_ROUTE_SALARY", "export", features)
      //       }
      //     />
      //     <Button
      //       icon={<PencilDash />}
      //       onClick={() => {
      //         getExportVersion(record._id, record.name);
      //       }}
      //       disabled={!checkPermissions("FIXED_ROUTE_SALARY", "edit", features)}
      //     />
      //   </Row>
      // ),
    },
  ];
  const dataSource = useMemo(() => {
    return data;
  }, [filters, data]);
  // Function to handle action
  const handleOnChangeRouter = async (
    router: any,
    id: string,
    dataSource: any,
  ) => {
    const detailRouter = await getOneRouter(router.value);
    const detail = detailRouter.data;
    var newDataSource = dataSource.map((ite: any) =>
      ite._id === id ? { ...ite, routeBase: detail, _id: id } : ite,
    );
    setData(newDataSource);
  };
  const refreshFreightRevenueVersions = async () => {
    const response: any = await FreightRevenueApi.getFreightVesion({});
    const versions = response?.data ?? [];

    setDataVersion(versions);
    setActiveVersion((currentVersion) =>
      currentVersion &&
      versions.some((version: any) => version._id === currentVersion)
        ? currentVersion
        : versions[0]?._id ?? null,
    );
  };
  const handleApplyFreightRevenueVersion = (record: any) => {
    if (!canApplyFreightVersion(record, canEditFreight)) return;

    const affectedOrderCount = getFreightVersionOrderCount(
      record.affectedOrderCount,
    );
    const pendingOrderCount = getFreightVersionOrderCount(
      record.pendingOrderCount,
    );

    confirm({
      title: "Áp dụng giá mới",
      content: (
        <div>
          <div>
            Phiên bản: <strong>{record.name || "-"}</strong>
          </div>
          <div>
            Đơn hàng bị ảnh hưởng: <strong>{affectedOrderCount}</strong>
          </div>
          <div>
            Đơn hàng chưa áp dụng: <strong>{pendingOrderCount}</strong>
          </div>
        </div>
      ),
      okText: "Áp dụng",
      cancelText: "Hủy",
      onOk: async () => {
        await runLocked(
          `freight-revenue:apply-version:${record._id}`,
          async () => {
            try {
              const response =
                await FreightRevenueApi.applyFreightRevenueVersionToOrders(
                  record._id,
                );
              if (response?.success === false) {
                throw new Error(response.message || "Áp dụng giá thất bại");
              }

              messageApi.success(
                response?.message || "Áp dụng giá mới thành công",
              );
              try {
                await refreshFreightRevenueVersions();
              } catch {
                messageApi.warning(
                  "Đã áp dụng giá nhưng chưa tải lại được số lượng đơn hàng",
                );
              }
            } catch (error: any) {
              messageApi.error(error?.message || "Áp dụng giá thất bại");
            }
          },
        );
      },
    });
  };
  const handleActionTableVersion = (
    action: string,
    record: any,
    index: string,
  ) => {
    switch (action) {
      case "edit":
        if (!checkPermissions("FREIGHT", "edit", features)) return;
        setEditIndexVersion([
          ...editIndexVersion,
          { index: index, record: { ...record } },
        ]);
        break;
      case "download":
        if (!checkPermissions("FREIGHT", "export", features)) return;
        FreightRevenueApi.getExportVersion(record._id, record.name);
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleActionTable = (action: string, record: any, index: string) => {
    switch (action) {
      case "detail":
        // setDetail(true);
        // formInstance.setFieldsValue({
        //   ...record,
        //   receipt: {
        //     value: record.receipt?.wId
        //       ? record.receipt.wId
        //       : record.receipt?.value,
        //     key: record.receipt?.wId
        //       ? record.receipt.wId
        //       : record.receipt?.value,
        //     label: record.receipt?.address,
        //   },
        //   delivery: {
        //     value: record.delivery?.wId
        //       ? record.delivery.wId
        //       : record.delivery?.value,
        //     key: record.delivery?.wId
        //       ? record.delivery.wId
        //       : record.delivery?.value,
        //     label: record.delivery?.address,
        //   },
        //   region: record.region?._id ?? record.region,
        // });
        break;
      case "edit":
        setEditIndex([...editIndex, { index: index, record: { ...record } }]);
        break;
      case "delete":
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn xoá bản ghi này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          onOk() {
            FreightRevenueApi.shortDeleteFreightRevenue({
              ids: [index],
            })
              .then(() => {
                setData((prev: any) =>
                  prev.filter((item: any) => item._id !== record._id),
                );
                setEditIndex((prev: any[]) =>
                  prev.filter((item) => item.index !== index),
                );
              })
              .catch((error) => {
                messageApi.error(
                  error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
                );
              });
          },
          onCancel() {},
        });
        // tìm index trong data theo id
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  // helpers imported from ./helpers.ts
  const handleUpdateRowVersion = (key: string, value: any, index: number) => {
    return setEditIndexVersion((prev: any[]) =>
      updateFreightRevenueEditedRows(prev, key, value, index),
    );
    // ✅ đánh dấu touched
  };
  const handleUpdateRow = (
    key: string | string[],
    value: any,
    index: string,
  ) => {
    return setEditIndex((prev: any[]) =>
      updateFreightRevenueEditedRows(prev, key, value, index, true),
    );
    // ✅ set nested field
    // ✅ đánh dấu touched
  };
  const handleActionSave = async (index: any, key: number) => {
    await runLocked(`freight-revenue:row:${index}`, async () => {
      try {
        const rowEdit = editIndex.find(
          (ind: any) => ind.index === index,
        )?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        const requiredAction = rowEdit.status === "new" ? "add" : "edit";
        if (!checkPermissions("FREIGHT", requiredAction, features)) {
          return;
        }
        const originalRowId = rowEdit._id ?? index;
        // ✅ check NULL các field req
        if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }
        const isNew = rowEdit.status === "new";
        // payload đúng shape API
        const payloadBase = buildFreightRevenueBasePayload(
          rowEdit,
          activeVersion,
        );
        const payloadFreightRevenue =
          buildFreightRevenueDetailsPayload(rowEdit);
        // ===== CALL API =====
        if (isNew) {
          const res = await FreightRevenueApi.postAddFreightRevenue({
            ...payloadBase,
            ...payloadFreightRevenue,
          });
          // ===== CHỈ KHI API OK =====
          delete rowEdit.status;
          rowEdit._id = res?.data?._id;
        } else {
          await FreightRevenueApi.putUpdateFreightRevenue(
            payloadFreightRevenue,
            rowEdit._id,
          );
        }
        // // ===== CHỈ KHI API OK =====
        setData((prev: any[]) =>
          replaceRowByOriginalId(
            prev,
            originalRowId,
            isNew
              ? {
                  ...rowEdit,
                  routeBase: prev.find(
                    (row: any) => (row._id ?? row.key) === originalRowId,
                  )?.routeBase,
                }
              : rowEdit,
          ),
        );
        setEditIndex((prev: any[]) =>
          prev.filter((ind: any) => ind.index !== index),
        );
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionSaveVersion = async (index: any, key: number) => {
    if (!checkPermissions("FREIGHT", "edit", features)) return;
    await runLocked(`freight-revenue:version:${index}`, async () => {
      try {
        const rowEdit = editIndexVersion.find(
          (ind: any) => ind.index === index,
        )?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        const originalRowId = rowEdit._id ?? index;
        // ✅ check NULL các field req
        if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS_VERSION)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }
        const isNew = rowEdit.status === "new";
        // payload đúng shape API
        const payload = buildFreightRevenueVersionPayload(rowEdit);
        const respone =
          await FreightRevenueApi.putUpdateFreightRevenueVersion(
            payload,
            index,
          );
        // ===== CHỈ KHI API OK =====
        if (respone.success) {
          setDataVersion((prev: any[]) =>
            replaceRowByOriginalId(prev, originalRowId, rowEdit),
          );
          setEditIndexVersion((prev: any[]) =>
            prev.filter((ind: any) => ind.index !== index),
          );
        }
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionCancel = (index: number) => {
    const editItem = editIndex.find((ind: any) => ind.index === index);
    if (editItem?.record?.status) {
      setData((prev: any) => prev.filter((_: any) => _._id !== index));
    }
    const newEdit = editIndex.filter((ind: any) => ind.index !== index);
    setEditIndex(newEdit);
  };
  const handleActionCancelVersion = (index: number) => {
    const editItem = editIndexVersion.find((ind: any) => ind.index === index);
    if (editItem?.record?.status) {
      setDataVersion((prev: any) => prev.filter((_: any) => _._id !== index));
    }
    const newEdit = editIndexVersion.filter((ind: any) => ind.index !== index);
    setEditIndexVersion(newEdit);
  };
  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setColumns(updateColumnDisplayState(columns, dataIndex, value, type));
  };
  const handleAddRow = () => {
    if (!checkPermissions("FREIGHT", "add", features)) {
      return;
    }

    const newObjCreate = {
      ...newObj,
      status: "new",
      _id: `create-${Date.now()}`,
    };
    setData([newObjCreate, ...dataSource]);
    setEditIndex([
      ...editIndex,
      { index: newObjCreate._id, record: newObjCreate },
    ]);
  };
  const handleOnShortDeleted = () => {
    confirm({
      title: "Xác nhận xoá",
      content: `Bạn có chắc chắn muốn xoá ${selectedRowKeys.length} bản ghi đã chọn không?`,
      okText: "Xoá",
      cancelText: "Huỷ",
      okType: "danger",
      onOk() {
        // Call API xoá nhiều
        FreightRevenueApi.shortDeleteFreightRevenue({
          ids: selectedRowKeys as string[],
        })
          .then(() => {
            setData((prev: any) =>
              prev.filter((item: any) => !selectedRowKeys.includes(item._id)),
            );
            setSelectedRowKeys([]);
          })
          .catch((error) => {
            messageApi.error(
              error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
            );
          });
      },
      onCancel() {
        setSelectedRowKeys([]);
      },
    });
  };
  // Function to render
  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          className: styles.ModalBody,
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định(trái, phải)</Col>
        </Row>
        <Divider />
        {columns?.map((col: any, key: number) => {
          return (
            <div key={key}>
              <Row>
                <Col span={16}>{col.title}</Col>
                <Col span={4}>
                  <Checkbox
                    checked={!col.hidden}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked,
                        "hidden",
                      );
                    }}
                  />
                </Col>
                <Col span={4}>
                  <Checkbox
                    checked={col.fixed === "left" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "left",
                        "fixed",
                      );
                    }}
                    style={{ marginRight: "20px" }}
                  />
                  <Checkbox
                    checked={col.fixed === "right" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "right",
                        "fixed",
                      );
                    }}
                  />
                </Col>
              </Row>
              <Divider />
            </div>
          );
        })}
      </Modal>
    );
  };
  //Function to effect
  useEffect(() => {
    if (canImportFreightRevenue) return;
    if (!openModalImport) return;

    setOpenModalImport(false);
    formInstance.resetFields();
  }, [
    canImportFreightRevenue,
    formInstance,
    openModalImport,
  ]);
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      // setLoading(true);
      const resDataVersion: any = await FreightRevenueApi.getFreightVesion({});
      const firstRenderVersion = resDataVersion?.data[0]?._id ?? "";
      if (mounted) {
        setDataVersion(resDataVersion?.data ?? []);
        setActiveVersion(firstRenderVersion);
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [increLoading]);
  useEffect(() => {
    let mounted = true;

    const fetchLookups = async () => {
      try {
        const [regions, direction]: any = await Promise.all([
          getPermissionRegions({}),
          getPermissionDirections({}),
        ]);

        if (!mounted) return;

        setRegionAndDirectionSelectOptions({
          region:
            regions?.map((region: any) => ({
              label: region.name,
              value: region._id,
            })) || [],
          direction:
            direction?.map((dir: any) => ({
              label: dir.name,
              value: dir.code,
            })) || [],
        });
      } catch (error: any) {
        if (mounted) {
          messageApi.error(error?.message || "Tải danh mục thất bại");
        }
      }
    };

    fetchLookups();

    return () => {
      mounted = false;
    };
  }, [messageApi]);
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      setLoading(true);
      const resDataFreightRevenue: any = await FreightRevenueApi.getAllFreight({
        current: paginationFreightRevenue.current,
        pageSize: paginationFreightRevenue.pageSize,
        version: activeVersion,
        ...filters,
      });
      if (mounted) {
        setLoading(false);
        setData(resDataFreightRevenue?.data ?? []);
        setPaginationFreightRevenue((prev) => ({
          ...prev,
          total: resDataFreightRevenue?.totalItem || 0,
        }));
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [
    filters,
    activeVersion,
    paginationFreightRevenue.current,
    paginationFreightRevenue.pageSize,
    increLoading,
  ]);
  useEffect(() => {
    setColumns(colsBase);
  }, [regionAndDirectionSelectOptions]);
  // Main render
  return (
    <PermissionDirect
      screen={["FREIGHT"]}
      // moreAction={() => {}}
      moreCondition={!checkPermissions("FREIGHT", "view", features)}
    >
      <div className={styles.FreightRevenue}>
        {contextHolder}
        <div className="container">
          <HeaderTable
            title="Cuớc doanh thu"
            buttons={[
              {
                children: "Mẫu import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (!checkPermissions("FREIGHT", "export", features)) return;
                  CommonApi.getDownloadTemplate(
                    "freight",
                    "Cước doanh thu.xlsx",
                  );
                },
                type: "primary",
                disabled: !checkPermissions("FREIGHT", "export", features),
              },
              {
                children: "Cài đặt hiển thị",
                icon: <Setting />,
                onClick: () => {
                  setOnModalPosition(true);
                },
                type: "primary",
              },
              {
                children: "Import",
                icon: <img src="/icon/xlsx.svg" />,
                onClick: () => {
                  if (!canImportFreightRevenue) return;
                  setOpenModalImport(true);
                },
                style: {
                  backgroundColor: checkPermissions(
                    "FREIGHT",
                    "import",
                    features,
                  )
                    ? "#00529F"
                    : "#C0C0C0",
                },
                disabled: !checkPermissions("FREIGHT", "import", features),
              },
            ]}
          />
          <Table
            columns={columnsRenderVersion}
            dataSource={dataVersion}
            pagination={{ pageSize: 3 }}
            size="small"
            scroll={{ x: "max-content" }}
            onRow={(record) => {
              return {
                onDoubleClick: (e) => {
                  const _id = record._id;
                  handleFreightRevenueVersionChange(_id);
                },
              };
            }}
            rowClassName={(record: any) =>
              record._id === activeVersion ? styles.HightLightRow : ""
            }
            rowKey={(record) => String(record._id)}
          />
          {checkPermissions("FREIGHT", "delete", features) &&
            selectedRowKeys.length > 0 && (
              <Button danger type="primary" onClick={handleOnShortDeleted}>
                Xoá
              </Button>
            )}
          <Table
            loading={loading}
            size="small"
            dataSource={dataSource}
            columns={columnsRender}
            scroll={{ x: "max-content" }}
            rowSelection={{
              selectedRowKeys: selectedRowKeys,
              onChange: (selectedKeys) => {
                setSelectedRowKeys(selectedKeys);
              },
            }}
            pagination={false}
            bordered
            style={{ width: "100%" }} // Full theo container
          />
        </div>
        <Button
          className={styles.ButtonPlus}
          icon={<PlusIcon />}
          onClick={handleAddRow}
          disabled={!checkPermissions("FREIGHT", "add", features)}
        >
          Thêm mới
        </Button>
        <Pagination
          total={paginationFreightRevenue.total}
          current={paginationFreightRevenue.current}
          pageSize={paginationFreightRevenue.pageSize}
          onChange={(page, pageSize) => {
            setPaginationFreightRevenue((prev) => ({
              ...prev,
              current: page,
              pageSize: pageSize || prev.pageSize,
            }));
          }}
          showSizeChanger
          align="end"
          className={styles.Pagination}
        />
        {renderModalPosition()}
        <ModalImport
          columns={columns}
          open={openModalImport}
          onCancel={() => {
            setOpenModalImport(false);
            formInstance.resetFields();
          }}
          precheckApi={async (file: Blob) => {
            if (!canImportFreightRevenue) {
              throw new Error("Bạn không có quyền import cước doanh thu");
            }
            return FreightRevenueApi.postPreCheckImportFreight(file);
          }}
          confirmApi={(payload) => {
            if (!canImportFreightRevenue) {
              return Promise.reject(
                new Error("Bạn không có quyền import cước doanh thu"),
              );
            }
            return formInstance.validateFields().then(() => {
              const val = formInstance.getFieldsValue([
                "expiredDate",
                "name",
                "onCopy",
                "cloneFromVersion",
              ]);
              return FreightRevenueApi.postConfirmImportFreight({
                ...payload,
                versionId: val.name === "new" ? payload.versionId : val.name,
                validFrom: new Date(val.expiredDate).toISOString(),
                cloneFromVersion: val.onCopy ? val.cloneFromVersion : undefined,
              }).then(() => {
                formInstance.resetFields();
                setIncreLoading(increLoading + 1);
              });
            });
          }}
        >
          <Form form={formInstance} {...configInputImportForm} />
        </ModalImport>
      </div>
    </PermissionDirect>
  );
};
export { FreightRevenue };
